import * as Yup from "yup";

// Shared ownership type enum (works for both vehicles and trailers)
export enum OwnershipType {
  CompanyOwned = 1,
  CompanyOwnedLeasedFrom = 2,
  CompanyOwnedLeasedTo = 3,
  NotCompanyOwned = 4
}

// Type aliases for specific entities
export type VehicleOwnershipType = OwnershipType;
export type TrailerOwnershipType = OwnershipType;

// Also export as const for compatibility
export const TrailerOwnershipType = OwnershipType;
export const VehicleOwnershipType = OwnershipType;

// Shared Owner Info type definition
export interface OwnerInfoFormValues {
  company: string;
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  ssnFein: string;
  bankAccount: string;
  contacts: string;
  email: string;
  website: string;
}

// Shared Lease From Info type definition
export interface LeaseFromInfoFormValues {
  lessorId: number | null;
  lessorName: string | null;
  startDate: string | null;
  endDate: string | null;
}

// Shared Lease To Info type definition
export interface LeaseToInfoFormValues {
  lesseeId: number | null;
  lesseeName: string | null;
  startDate: string | null;
  endDate: string | null;
}

// Shared ownership validation schemas (reusable for vehicles and trailers)
export const ownerInfoValidationSchema = Yup.object().shape({
  company: Yup.string().required("Company name is required"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zipCode: Yup.string().required("ZIP code is required"),
  ssnFein: Yup.string().required("SSN/FEIN is required"),
  bankAccount: Yup.string(),
  contacts: Yup.string(),
  email: Yup.string(),
  website: Yup.string(),
});

export const leaseFromInfoValidationSchema = Yup.object().shape({
  lessorId: Yup.number().nullable(),
  lessorName: Yup.string().nullable(),
  startDate: Yup.date().nullable().required("Lease start date is required"),
  endDate: Yup.date().nullable(),
});

export const leaseToInfoValidationSchema = Yup.object().shape({
  lesseeId: Yup.number().nullable(),
  lesseeName: Yup.string().nullable(),
  startDate: Yup.date().nullable().required("Lease start date is required"),
  endDate: Yup.date().nullable(),
});